import { api_url, auth_endpoint, client_id } from './config.json';

const redirect_uri = window.location.origin + window.location.pathname;

export {
  api_url,
  auth_endpoint,
  client_id,
  redirect_uri
};
